import React from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";

const CarMasterValue = ({ addLink="/", value="", setValue, type="", arrayData=[] }) => {
    function showTitle(v) {
        return v;
    }
    return (
        <> 
            <div className="d-flex align-items-center justify-content-between">
                <label className="form-label">
                    {showTitle(type)} <span className="text-danger">*</span>
                </label>
                <Link
                    to={addLink}
                    className="link-info mb-2"
                >
                    Add New
                </Link>
            </div>
            <select
                value={value} // Pass the object directly
                className="form-control"
                style={{ width: '100%' }}
                onChange={(e) => {
                    setValue(type, e.target.value);
                }}
            >
                <option value="0">Select</option>
                {arrayData.map((option) => (
                    <option key={option._id} value={option._id}>
                        {option.title}
                    </option>
                ))}
            </select>
        </>
    );
};


CarMasterValue.propTypes = {
  addLink: PropTypes.string.isRequired, // or PropTypes.string if not required
  value: PropTypes.string.isRequired,
  setValue: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  arrayData: PropTypes.string.isRequired
};

export default CarMasterValue;
